import React, { useCallback, useState, useEffect, useRef } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./SearchBar.css";

const SearchBar = React.memo(({ searchQuery, setSearchQuery }) => {
  const [localValue, setLocalValue] = useState(searchQuery);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setLocalValue(searchQuery);
  }, [searchQuery]);

  const handleChange = useCallback((e) => {
    const value = e.target.value;
    setLocalValue(value);
    
    // Clear previous timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    // Debounce the actual search query update
    timeoutRef.current = setTimeout(() => {
      setSearchQuery(value);
    }, 300);
  }, [setSearchQuery]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="search-bar-container">
      <Input
        placeholder="Search IMEI/Name..."
        prefix={<SearchOutlined />}
        value={localValue}
        onChange={handleChange}
        className="search-input"
        allowClear
      />
    </div>
  );
});

export default SearchBar;
